'use strict';

function getRules() {
    return {
        is_project:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        project_name:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        resource_type:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        user:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        end_time:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        resource_count:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        location:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],

    };
}
export {
    getRules
}

